import { createSelector } from 'reselect'
import { createNamespacedSelector } from '../namespaces'
import { attackPatternFormatting } from './dataFormatting'
export const selectActors = state => state.intelApi.actors
export const selectMitreAttack = state => state.intelApi.mitreAttackStore.mitreAttack
export const selectActorAncestry = state => state.intelApi.actorAncestry?.data

export const selectMitreAttackPatterns = createSelector(
  selectMitreAttack,
  (_, ids) => ids,
  (mitreAttack, ids, page) => {
    if (mitreAttack) {
      const { patterns } = mitreAttack
      const attackPattern = patterns.find(pattern => pattern.id === ids[0])
      if (attackPattern) {
        const { data } = attackPattern
        const { items: elements = [], 'attack-patterns': attackPatternsDict = {} } = data
        return { data, formattedAttackPatterns: attackPatternFormatting(elements, ids, attackPatternsDict, {}, page) }
      }
    }
  }
)

export const createFetchedSelector = createNamespacedSelector(state => state.intelApi.fetched)
